import { render } from "./SidePanel.vue?vue&type=template&id=4bc067b6&scoped=true"
import script from "./SidePanel.vue?vue&type=script&lang=js"
export * from "./SidePanel.vue?vue&type=script&lang=js"

import "./SidePanel.vue?vue&type=style&index=0&id=4bc067b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LMPELCHAT\\Documents\\vie-associative\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc067b6"]])

export default __exports__